require.context("../images", true);
import "entrypoints/decidim_volunteering_registration.scss";
import "src/decidim/volunteering/registration/registration_volunteer";
